import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'

import { useExportJobContext } from 'common/contexts/useExportJobContext'

import DataExport from './DataExport'
import DataImport from './DataImport'
import ImportExportToolbar from './Toolbar/ImportExportToolbar'

const ImportExport = () => {
  const ImportViewWrapper = (): JSX.Element => <DataImport />
  const ExportViewWrapper = (): JSX.Element => <DataExport />
  const { exportJob, jobStatus } = useExportJobContext()

  const [exportPendingText, setExportPendingText] = useState('Domain Guide')

  const ENABLE_EXPORT_ONLY =
    import.meta.env.VITE_ENABLE_DATA_EXPORT_ONLY?.toLowerCase() === 'true'

  const dataExportLabel = ENABLE_EXPORT_ONLY
    ? 'Data Export'
    : 'Data Import & Export'

  useEffect(() => {
    if (
      (exportJob.isSuccess || exportJob.isError) &&
      jobStatus === 'success' &&
      exportPendingText === 'Downloading Domain Guide'
    ) {
      setExportPendingText('Domain Guide')
    }
  }, [
    exportJob.isError,
    exportJob.isFetching,
    exportJob.isSuccess,
    exportPendingText,
    jobStatus
  ])

  return (
    <div className='flex flex-1 flex-col'>
      <header className='bg-white px-28'>
        <div className='mb-10 mt-14'>
          <span
            className={[
              'block font-medium uppercase',
              'tracking-[0.03em] text-lighthouseBlue',
              'leading-none'
            ].join(' ')}
          >
            Data Management
          </span>
          <div className='flex items-center justify-between text-3xl font-semibold'>
            <h1 className='mt-3'>{dataExportLabel}</h1>
          </div>
        </div>
        <ImportExportToolbar />
      </header>
      <div className='flex flex-1 overflow-y-auto bg-gray-100'>
        <Routes>
          <Route path='export' element={<ExportViewWrapper />} />
          <Route path='import' element={<ImportViewWrapper />} />
          <Route path='*' element={<ExportViewWrapper />} />
        </Routes>
      </div>
    </div>
  )
}

export default ImportExport
